module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex family"
  }, [_c('div', {
    staticClass: "basic"
  }, [_c('family-profile', {
    attrs: {
      "family": _vm.family,
      "edit_id": _vm.edit_id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-AddBox"
  }, [_c('family-students-index', {
    attrs: {
      "family": _vm.family
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-support"
  }, [_c('family-history', {
    attrs: {
      "family": _vm.family,
      "condition": _vm.condition,
      "edit_id": _vm.edit_id,
      "type": "true"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef02c032"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Family/FamilyIndex.vue
// module id = 1484
// module chunks = 0